<template>
    <label class="flex-form__field" :class="getInvalidClass('collectionId')">
        <div class="flex-form__label">
            Collection ID
            <tooltip>
                On Component Editor, copy Collection ID by click on the Finger Print (fingerprint) Icon.
            </tooltip>
        </div>

        <input v-model="dataNew.collectionId" class="flex-form__input">
    </label>
</template>

<script>
import eventDataMixin from '@/mixins/event-data';

export default {
    name: 'trigger-collection-load',
    mixins: [eventDataMixin],

    data() {
        return {
            schema: {
                collectionId: {
                    type: String,
                    default: '',
                    required: true,
                },
            },
        };
    },
};
</script>
